import { DTOAdapter } from '../../services/DTOs/DTOAdapter'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { LandingPage } from '../domain/LandingPage'
import { LandingPageDTO } from './LandingPageDTO'
import { environment } from '../../../environments/environment'
import { map } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class LandingPageService {

    constructor(
        private http: HttpClient,
        private dtoAdapter: DTOAdapter
    ) { }

    getLandingPage(venueId: string) {
        const url = environment.apiBaseUrl + '/landing-page/' + venueId
        return this.http.get<LandingPageDTO>(url)
            .pipe(
                map(dto => this.adaptLandingPageDTO(dto))
            )
    }

    getLandingPageBySlug(venueSlug: string) {
        const url = environment.apiBaseUrl + '/landing-page/venue-slug/' + venueSlug
        return this.http.get<LandingPageDTO>(url)
            .pipe(
                map(dto => this.adaptLandingPageDTO(dto))
            )
    }

    private adaptLandingPageDTO(dto: LandingPageDTO): LandingPage {
        return new LandingPage(
            this.dtoAdapter.adaptAddressDto(dto.address),
            dto.bookingPath,
            dto.displayName,
            dto.emailAddress,
            dto.phoneNumber,
            dto.timeZone,
            dto.inService ?? true,
            dto.voucher ? this.dtoAdapter.adaptVoucherDto(dto.voucher) : null,
            dto.metaPixelId ?? null
        )
    }
}
